import React from 'react';
import { TabsLeft, TabsTop } from '.';
import { graphql } from 'gatsby';
interface TabsProps<T = TabItem> {
  block: {
    _template: string;
    theme: string;
    css_class_name: string;
    tab_position: string;
    show_bunnies_image: boolean;
    header_col: string;
    data_col: string;
    tab_list: TabListType<T>;
  };
}

const Tabs: React.FC<TabsProps<DetailedTabItem>> = ({ block }) => {
  const isTabCard = block.tab_list.some(tab => {
    return tab.tab_is_card;
  });

  return (
    <section
      className={`block ${block._template} ${block.css_class_name} ${block.tab_position} ${block.show_bunnies_image ? 'show-image' : ''}`}
    >
      <div
        className={`container container--${block.tab_position} ${isTabCard ? '!gap-16' : ''}`}
      >
        {['pos-left', 'pos-right'].includes(block.tab_position) ? (
          <TabsLeft tabsData={block} />
        ) : (
          <TabsTop
            tabsData={block}
            isTabCard={isTabCard}
          />
        )}
      </div>
    </section>
  );
};

export default Tabs;

export const simpleTabFramentQuery = graphql`
  fragment SimpleTabItemFragment on SimpleTabItem {
    _template
    show_background
    tab_title
    tab_text
    tab_is_card
    tab_icon
    html
    image
    image_alt_text
    text
    font_size
    style
  }
`;

export const detailedTabFragmentQuery = graphql`
  fragment DetailedTabItemFragment on DetailedTabItem {
    _template
    tab_title
    style
    tab_icon
    tab_base_text
    title
    text
    html
    image
    image_url
    image_alt_text
    image_field {
      ...ImageFieldFragment
    }
    values {
      value
    }
    cta_field {
      ...CtaFieldFragment
    }
  }
`;

export const tabsFragmentQuery = graphql`
  fragment TabsBlockFragment on Block {
    _template
    theme
    css_class_name
    tab_position
    show_bunnies_image
    header_col
    data_col
    tab_list {
      ... on DetailedTabItem {
        __typename
        ...DetailedTabItemFragment
      }
      ... on SimpleTabItem {
        __typename
        ...SimpleTabItemFragment
      }
    }
  }
`;
